import React from 'react';
import { useDispatch } from 'react-redux';
import { Route, Navigate } from 'react-router-dom';

import { APICore } from '../helpers/api/apiCore';
import { resetAuth } from '../redux/actions';

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: Component, roles, ...rest }) => {
    const api = new APICore();
    const dispatch = useDispatch();

    return (
        <Route
            {...rest}
            render={(props) => {
                if (api.isUserAuthenticated() === false) {
                    // not logged in so redirect to login page with the return url
                    dispatch(resetAuth());
                    return <Navigate to={{ pathname: '/account/login', state: { from: props.location } }} />;
                }

                const loggedInUser = api.getLoggedInUser();

                if (roles && roles.indexOf(loggedInUser.role) === -1) {
                    // role not authorised so redirect to home page
                    return <Navigate to={{ pathname: '/' }} />;
                }

                // authorised so return component
                return <Component {...props} />;
            }}
        />
    );
};

export default PrivateRoute;
